import { Button, Box } from '@mui/material';
import { UnreviewedCheckinsTabsKeys } from '@/types';
import { CheckinSummary } from '@/types/api';
import styles from './UnreviewedCheckinsTabs.styles';
import RemindPeopleToCheckInButton from '../RemindPeopleToCheckInButton';

export type UnreviewedCheckinsTabsProps = {
  handleChangeView: (view: UnreviewedCheckinsTabsKeys) => void;
  view: UnreviewedCheckinsTabsKeys;
  AllUnreviewedCheckins: CheckinSummary[];
  totalPeopleToBeReminded: number;
  handleStartReviewingCheckins: (groupOfCheckins: CheckinSummary[]) => void;
  handleNotifyEveryone: () => void;
};

const UnreviewedCheckinsTabs = function ({
  view,
  AllUnreviewedCheckins,
  handleStartReviewingCheckins,
  handleChangeView,
  totalPeopleToBeReminded,
  handleNotifyEveryone,
}: UnreviewedCheckinsTabsProps): JSX.Element {
  const isEveryoneView = view === UnreviewedCheckinsTabsKeys.EVERYONE;
  const hasAnsweredCheckinsToBeReviewed = AllUnreviewedCheckins.some(
    (checkin) => checkin.answeredAt
  );

  return (
    <Box sx={styles.wrapper}>
      <div>
        <Button
          sx={styles.firstTabButton}
          variant={view === UnreviewedCheckinsTabsKeys.TEAM ? 'contained' : 'outlined'}
          onClick={() => handleChangeView(UnreviewedCheckinsTabsKeys.TEAM)}
        >
          Teams
        </Button>
        <Button
          variant={view === UnreviewedCheckinsTabsKeys.EVERYONE ? 'contained' : 'outlined'}
          onClick={() => handleChangeView(UnreviewedCheckinsTabsKeys.EVERYONE)}
        >
          Everyone
        </Button>
      </div>
      <div>
        {!!totalPeopleToBeReminded && isEveryoneView && (
          <RemindPeopleToCheckInButton
            amountOfUsersToNotify={totalPeopleToBeReminded}
            handleNotifyUsers={handleNotifyEveryone}
          />
        )}
        {isEveryoneView && hasAnsweredCheckinsToBeReviewed && (
          <Button
            onClick={() => handleStartReviewingCheckins(AllUnreviewedCheckins)}
            variant="contained"
          >
            Start reviewing
          </Button>
        )}
      </div>
    </Box>
  );
};

export default UnreviewedCheckinsTabs;
